/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getPaymentGateway } from '../../../api/flightApi';
import { getObjectFromLS } from '../../../shared/helper-utils/localStorage';
import { isEmpty } from '../../../shared/helper-utils/appUtils';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import { APP_USER_PROFILE } from '../../../saas/AppStorageStaticNames';

function PaymentGatewayApii({
  paymentModeClicked,
  selectedPgForPaymentMode,
  onPgSelect,
}) {
  const selectedPaymentGatewayRef = useRef([]);
  const [PaymentGateway, setPaymentGateway] = useState(false);
  const [tempPgfullList, setTempPgfullList] = useState([]);

  const fetchPGData = async () => {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getPaymentGateway(userProfile?.agentId);
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const availPgs = response?.Root?.Result?.AvailablePaymentGateways;
      if (!isEmpty(availPgs)) {
        let pglist = availPgs.AvailablePaymentGateway;
        pglist = Array.isArray(pglist) ? pglist : [pglist];
        selectedPaymentGatewayRef.current = pglist;
        if (paymentModeClicked === '') {
          const pgForCreditCard = pglist.filter(
            (x) => x.PaymentMode.toLowerCase() === 'creditcard',
          );
          setTempPgfullList(pgForCreditCard);
          if (pgForCreditCard.length > 0) {
            onPgSelect(pgForCreditCard[0].GatewayName);
          }
        } else {
          const pgForCreditCard = pglist.filter(
            (x) => x.PaymentMode.toLowerCase() === paymentModeClicked,
          );
          setTempPgfullList(pgForCreditCard);
          if (pgForCreditCard.length > 0) {
            onPgSelect(pgForCreditCard[0].GatewayName);
          }
        }

        setPaymentGateway(true);
      }
    }
  };

  const updatePaymentMode = (pmselected) => {
    const pgForPmSelected = selectedPaymentGatewayRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === pmselected,
    );
    if (pgForPmSelected.length > 0) {
      onPgSelect(pgForPmSelected[0].GatewayName);
    }
    setTempPgfullList(pgForPmSelected);
  };

  useEffect(() => {
    updatePaymentMode(paymentModeClicked);
  }, [paymentModeClicked]);

  useEffect(() => {
    fetchPGData();
  }, []);

  return (
    <div className="d-flex justify-content-start gap-4">
      {PaymentGateway === true && tempPgfullList.length > 0 && (
        <div className="d-flex justify-content-start gap-4">
          <div className="flight-booking-page_title">Payment Gateway</div>
          {tempPgfullList.map((pgdisp, index) => (
            <AppRadioInput
              key={index}
              id={pgdisp.GatewayName}
              name="paymentGateway"
              labelText={
                pgdisp.GatewayName === 'techprocessv2'
                  ? 'Worldline'
                  : pgdisp.GatewayName
              }
              value={pgdisp.GatewayName}
              onClick={() => onPgSelect(pgdisp.GatewayName)}
              checked={selectedPgForPaymentMode === pgdisp.GatewayName}
            />
          ))}
        </div>
      )}
    </div>
  );
}
PaymentGatewayApii.propTypes = {
  paymentModeClicked: PropTypes.string.isRequired,
  selectedPgForPaymentMode: PropTypes.any.isRequired,
  onPgSelect: PropTypes.func.isRequired,
};
export default PaymentGatewayApii;
